
import Feature from '../node_modules/ol/Feature.js';
import GeomPoint from '../node_modules/ol/geom/Point.js';
import GeomPolygon from '../node_modules/ol/geom/Polygon.js';
import GeomMultiPolygon from '../node_modules/ol/geom/MultiPolygon.js';
import GeomLineString from '../node_modules/ol/geom/LineString.js';

import {map} from './index.js';
import {changePage} from './changePage.js';
import zoomToVectorExtents from './zoomToVectorExtents.js';


/** Adds a single GeoJSON feature to lyrVectorSource
    Optional paramater zoom2 is used by info tool to prevent page change & zooming to feature.
    When zoom2 is not set we're probably mapping a search result and we do want to change
    to the mappage, clear the vector layer and zoom to the feature.

    Aug 11, 2016 - begin support for SC style vector obj which has a polygon and a label point object.
      see: /rwg/doc/notes/OpenLayers/ol3/VectorNotes.txt
      and: /rwg/doc/notes/postgres_postgis/select_GeoJSON.sql
    Simple (original) format of json_string:
      {
        type: "Point|Polygon|MultiPolygon"
        coordinates: ....
      }
    Complex (newer) format that includes polygon and a label point:
      {
        geom:  {
            type: "Point|Polygon|MultiPolygon"
            coordinates: ....
          },
        label: "address number"
      }
*/
export default function(json_string, zoom2) {
  if (!json_string) return;

  let feature
  let geom
  let obj = JSON.parse(json_string)

  if (typeof obj.geom !== 'undefined') { // obj has a geom & label
    geom = JSON.parse(obj.geom);
  } else {  // simple case where obj is the geom and there's no label
    geom = obj;
  }
  if (!geom) return;

  switch (geom.type) {
    case 'Point':
      feature = new Feature(new GeomPoint(geom.coordinates));
      break;
    case 'LineString':
      feature = new Feature(new GeomLineString(geom.coordinates));
      break;
    case 'Polygon':
      feature = new Feature(new GeomPolygon(geom.coordinates));
      break;
    case 'MultiPolygon':
      feature = new Feature(new GeomMultiPolygon(geom.coordinates));
      break;
    default:
      console.error('unsuported geom type:', geom.type);
  }

  if (feature) {
    // add properties to the new feature
    for (const key in obj) {
      if (key !== 'geom') {
        if (key === 'id') {
          feature.setId(obj[key]);
        } else {
          feature.set(key, obj[key]);
        }
      }
    }

    if (feature.get('stylename')) { // feature has a named style that is registered in rwg.styles.list
                                    // the style is defined in etc/conf.js or in Styles.js
      let stylename = feature.get('stylename')
      feature.setStyle((feature, resolution) => { // this assumes that feature also has a "label" property
        return rwg.styles.get(stylename, {
          text: {text: feature.get('label')}
        })
      })
    }

    let lyrVectorSource = map.getLayerByTitle('lyrVector').getSource();
    // If we're using selection sets they take care of clearing the lyrVectorSource (or not)
    // so we want to add features to lyrVectorSource. But in the mobile version
    // we don't use selection sets SHOULD FIND A DIFFERENT PLACE TO CLEAR lyrVectorSource
    // if ( typeof rwg.selection === "undefined")  {
    //   lyrVectorSource.clear(); // there is a .removeFeature() method also
    // }
    // zoom2 will be true when called from search results mapIt() but false from info tool
    // if (zoom2 && !rwg.selection) { // 2023-03-08 removed "!rwg.selection"
    if (zoom2) {
      lyrVectorSource.clear();
    }
    lyrVectorSource.addFeature(feature);
    if (zoom2) {
      if (typeof changePage === 'function') {
        changePage('mappage');
      }
      // map.updateSize();   // fixes map sometimes not displaying
      // map.getView().fit(lyrVectorSource.getExtent(), map.getSize());
      zoomToVectorExtents();
    }
  }
}
